import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF"
import { faFacebookMessenger } from "@fortawesome/free-brands-svg-icons/faFacebookMessenger"
import { faPinterest } from "@fortawesome/free-brands-svg-icons/faPinterest"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter"
import { faShareAlt } from "@jewlr/pro-solid-svg-icons/faShareAlt"
import {
  Button,
  Flex,
  FontAwesomeIcon,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import styled from "styled-components"

import socialShare from "helpers/social-share"
import WebShareApi from "helpers/web-share-api"

const SocialGroup = styled(Flex)`
  align-items: center;
  color: ${(props) => props.theme.colors.black};
  gap: 18px;
`

const SocialIcon = styled(FontAwesomeIcon).attrs({
  height: "18px",
  width: "18px",
})``

const WebShare = styled(Button).attrs({
  variant: "text",
})`
  align-items: center;
  color: black;
  display: flex;
  font-size: 16px;
  font-weight: 500;
  justify-content: center;
  line-height: 20px;
  mb: 20px;
`

const ShareArticle = ({ article }) => {
  const [nativeShare, setNativeShare] = useState(true)

  useEffect(() => {
    if (!WebShareApi.shareIsSupported()) {
      setNativeShare(false)
    }
  }, [])

  const doSocialShare = (share_type, e) => {
    let popup = null
    if (share_type === "Twitter" || share_type === "Pinterest") {
      popup = window.open("", "_blank", "status=1,width=650,height=550")
    }
    e.preventDefault()

    const share_properties = {
      clickLabel: article.title,
      clickType: `Article ${share_type} Share`,
      imageUrl: "https://assets.jewlr.com/images/logos/jewlr-logo.svg",
      message: `Check this out from Jewlr! ${article.title}`,
      popup,
      url: window.location.href,
    }

    socialShare({ share_type, ...share_properties })
  }

  const doNativeShare = (e) => {
    e.preventDefault()
    WebShareApi.triggerWebShare(
      "Jewlr",
      `Check this out from Jewlr! ${article.title}`,
      window.location.href,
      (err) => {
        if (err) {
          console.log(err)
        }
      }
    )
  }

  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      mb={{ _: 2, tablet: 5 }}
      mt={{ _: 7, tablet: 9 }}
    >
      {nativeShare ? (
        <WebShare onClick={(e) => doNativeShare(e)}>
          Share This Article
          <SocialIcon icon={faShareAlt} ml={1} />
        </WebShare>
      ) : (
        <>
          <Typography
            fontSize="16px"
            fontWeight="500"
            lineHeight="20px"
            mb="20px"
          >
            Share This Article
          </Typography>
          <SocialGroup>
            <Button
              aria-label="Share this article via Facebook"
              onClick={(e) => doSocialShare("Facebook", e)}
              variant="text"
            >
              <SocialIcon icon={faFacebookF} />
            </Button>
            <Button
              aria-label="Share this article via X"
              onClick={(e) => doSocialShare("Twitter", e)}
              variant="text"
            >
              <SocialIcon icon={faXTwitter} />
            </Button>
            <Button
              aria-label="Share this article via Pinterest"
              onClick={(e) => doSocialShare("Pinterest", e)}
              variant="text"
            >
              <SocialIcon icon={faPinterest} />
            </Button>
            <Button
              aria-label="Share this article via Messenger"
              onClick={(e) => doSocialShare("Messenger", e)}
              variant="text"
            >
              <SocialIcon icon={faFacebookMessenger} />
            </Button>
          </SocialGroup>
        </>
      )}
    </Flex>
  )
}

ShareArticle.propTypes = {
  article: PropTypes.object,
}

export default ShareArticle
